
import Vue from "vue";
import { Component } from "vue-property-decorator";
import TopNavNotificationBar from "./TopNavNotificationBar.vue";
import FutureLayerIconAndWarningWrapper from "../FutureLayerIconAndWarningWrapper.vue";

@Component({
  components: {
    TopNavNotificationBar,
    FutureLayerIconAndWarningWrapper
  }
})
export default class TopNav extends Vue {

}
